// extracted by mini-css-extract-plugin
module.exports = {"footer":"NotificationsFooter_footer__HZAqx","paginatorContainer":"NotificationsFooter_paginatorContainer__2Ltj6"};